module.exports = __webpack_public_path__ + "static/media/Grouse.svg";